import React, { useState } from 'react'
import '../styles/Navbar.styles.css'
import LogoRosmo from '../assets/logo.png'
import useDeviceDetection from '../hooks/useDeviceDetection'
import { RiMenu5Fill } from 'react-icons/ri';
import { IoClose } from 'react-icons/io5';

export default function Navbar() {
  const isMobile = useDeviceDetection();
  const [showMenu, setShowMenu] = useState(false);
  const goSection = (section) => {
    const targetElement = document.getElementById(section);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
  return (
    <>
    <nav className='navbar'>
      <div className='nb-container'>
        <div className='nb-logoContainer'>
          <img className={isMobile ? 'nb-mobileLogo':'nb-logo'} src={LogoRosmo} alt='ROSMO-LOGO' onClick={()=>goSection('inicio')}/>
        </div>
        <div className='nb-sectionsContainer'>
          <div className='nb-section'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('inicio')}>INICIO</label>
          </div>
          <div className='nb-section'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('nosotros')}>NOSOTROS</label>
          </div>
          <div className='nb-section'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('constructora')}>CONSTRUCTORA</label>
          </div>
          <div className='nb-section'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('desarrolladora')}>DESARROLLADORA</label>
          </div>
          <div className='nb-section'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('inmobiliaria')}>INMOBILIARIA</label>
          </div>
        </div>
        <div className='nb-contactContainer'>
          <div className='nb-contact'>
            <label className={isMobile ? 'mobile' : null} onClick={()=>goSection('contacto')}>CONTACTO</label>
          </div>
          <div className='nb-menu'>
            <button onClick={()=>setShowMenu(!showMenu)}>{showMenu ? <IoClose /> : <RiMenu5Fill />}</button>
          </div>
        </div>
      </div>
    </nav>
    {
      showMenu && 
      <div className='nb-mobileMenu' onClick={()=>setShowMenu(false)} >
        <div className='nb-menuHeader'></div>
        <div className='nb-menuBody'>
          <div className='nb-sectionContainer' onClick={()=>goSection('inicio')}>
            INICO
          </div>
          <div className='nb-sectionContainer' onClick={()=>goSection('nosotros')}>
            NOSOTROS
          </div>
          <div className='nb-sectionContainer' onClick={()=>goSection('constructora')}>
            CONSTRUCTORA
          </div>
          <div className='nb-sectionContainer' onClick={()=>goSection('desarrolladora')}>
            DESRROLLADORA
          </div>
          <div className='nb-sectionContainer' onClick={()=>goSection('inmobiliaria')}>
            INMOBILIARIA
          </div>
          <div className='nb-sectionContainer' onClick={()=>goSection('contacto')}>
            CONTACTO
          </div>
        </div>
      </div>
    }
    </>
  )
}